import React, { useState, useEffect } from "react";
import { Field, useFormikContext } from "formik";
import { TextField, Grid, MenuItem, Typography, Button } from "@mui/material";

import Select from "react-select";
import { Public } from "@mui/icons-material";

const PersonalInfoStep = React.memo(({ metadata }) => {
    const { values, errors, touched, setFieldValue } = useFormikContext();
    const [stateOptions, setStateOptions] = useState([]);
    const [churchOptions, setChurchOptions] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);

    useEffect(() => {
        const states = metadata?.states?.map((state) => ({
            value: state.id,
            label: state.name,
        })) || [];
        setStateOptions(states);

        // Preparar las opciones del select con las iglesias del metadata
        const options = metadata?.churches?.map((church) => ({
            value: church.id,
            label: church.name,
        })) || [];
        setChurchOptions(options);

        // Si solo hay una iglesia, establecerla por defecto en Formik
        if (options.length === 1) {
            setFieldValue("church_id", options[0].value);
        }

        const groups = metadata?.groups?.map((group) => ({
            value: group.id,
            label: group.name,
        })) || [];
        setGroupOptions(groups);

    }, [metadata, setFieldValue]);





    const handleSetForeignState = () => {
        const foreignState = stateOptions.find(
            (option) => option.label.toLowerCase() === "nacido en el extranjero"
        );
        if (foreignState) {
            setFieldValue("birth_state_id", foreignState.value);
        } else {
            console.warn("No se encontró el estado 'Nacido en el Extranjero' en el metadata");
        }
    };

    return (
        <Grid container spacing={3}>
            {/* Nombre */}
            <Grid item xs={12} sm={6}>
                <Field name="first_name">
                    {({ field }) => (
                        <TextField
                            {...field}
                            label="Nombre(s)"

                            fullWidth
                            variant="outlined"
                            error={(touched.first_name && errors.first_name)}
                            helperText={touched.first_name && errors.first_name}
                        />
                    )}
                </Field>
            </Grid>

            {/* Apellido Paterno */}
            <Grid item xs={12} sm={6}>
                <Field name="middle_name">
                    {({ field }) => (
                        <TextField
                            {...field}
                            label="Apellido Paterno"
                            fullWidth
                            variant="outlined"
                            error={(touched.middle_name && errors.middle_name)}
                            helperText={touched.middle_name && errors.middle_name}
                        />
                    )}
                </Field>
            </Grid>

            {/* Apellido Materno */}
            <Grid item xs={12} sm={6}>
                <Field name="last_name">
                    {({ field }) => (
                        <TextField
                            {...field}
                            label="Apellido Materno"
                            fullWidth
                            variant="outlined"
                            error={Boolean(touched.last_name && errors.last_name)}
                            helperText={touched.last_name && errors.last_name}
                        />
                    )}
                </Field>
            </Grid>

            {/* Género */}
            <Grid item xs={12} sm={6}>
                <Field name="gender">
                    {({ field }) => (
                        <TextField
                            {...field}
                            select
                            label="Género"
                            fullWidth
                            variant="outlined"
                            error={Boolean(touched.gender && errors.gender)}
                            helperText={touched.gender && errors.gender}
                        >
                            <MenuItem value="male">Masculino</MenuItem>
                            <MenuItem value="female">Femenino</MenuItem>
                        </TextField>
                    )}
                </Field>
            </Grid>

            {/* Fecha de Nacimiento */}
            <Grid item xs={12} sm={6}>
                <Field name="birthdate_date">
                    {({ field }) => (
                        <TextField
                            {...field}
                            label="Fecha de Nacimiento"
                            type="date"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            error={Boolean(touched.birthdate_date && errors.birthdate_date)}
                            helperText={touched.birthdate_date && errors.birthdate_date}
                        />
                    )}
                </Field>
            </Grid>






            {/* Teléfono */}
            <Grid item xs={12} sm={6}>
                <Field name="phone">
                    {({ field }) => (
                        <TextField
                            {...field}
                            label="Teléfono Casa"
                            fullWidth
                            variant="outlined"
                            error={Boolean(touched.phone && errors.phone)}
                            helperText={touched.phone && errors.phone}
                        />
                    )}
                </Field>
            </Grid>

            {/* Móvil */}
            <Grid item xs={12} sm={6}>
                <Field name="mobile">
                    {({ field }) => (
                        <TextField
                            {...field}
                            label="Celular - WhatsApp"
                            fullWidth
                            variant="outlined"
                            error={Boolean(touched.mobile && errors.mobile)}
                            helperText={touched.mobile && errors.mobile}
                        />
                    )}
                </Field>
            </Grid>

            {/* Correo Electrónico */}
            <Grid item xs={12} sm={6}>
                <Field name="email">
                    {({ field }) => (
                        <TextField
                            {...field}
                            label="Correo Electrónico"
                            fullWidth
                            variant="outlined"
                            error={Boolean(touched.email && errors.email)}
                            helperText={touched.email && errors.email}
                        />
                    )}
                </Field>
            </Grid>

            <Grid item xs={12} sm={6}>
                <Field name="occupation">
                    {({ field }) => (
                        <TextField
                            {...field}
                            label="Ocupación"
                            fullWidth
                            variant="outlined"
                            error={Boolean(touched.occupation && errors.occupation)}
                            helperText={touched.occupation && errors.occupation}
                        />
                    )}
                </Field>
            </Grid>


            <Grid item xs={12} sm={6}>
                <Typography>Seleccionar Iglesia</Typography>
                <Select
                    options={churchOptions} // Usa las opciones del estado local
                    value={
                        churchOptions.find((church) => church.value == values.church_id) || null
                    }
                    onChange={(option) => setFieldValue("church_id", option?.value || "")}
                    placeholder="Seleccionar Iglesia"
                    isClearable
                />
            </Grid>


            <Grid container item xs={12} sm={6} alignItems="center" style={{ display: "flex" }}>
                {/* Selector de Estado */}
                <Grid item xs={12} sm={6} style={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="subtitle1">Estado de Nacimiento</Typography>
                    <Select
                        options={stateOptions}
                        value={stateOptions.find((option) => option.value === values.birth_state_id) || null}
                        onChange={(option) => setFieldValue("birth_state_id", option?.value || "")}
                        placeholder="Seleccione el Estado de Nacimiento"
                        isClearable
                    />
                </Grid>

                {/* Botón */}
                <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                        paddingTop: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        marginLeft: 16, // Espaciado horizontal entre el selector y el botón
                    }}
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<Public />}
                        onClick={handleSetForeignState}
                        style={{
                            height: "100%", // Asegurar que el botón tenga la misma altura que el selector si es necesario
                        }}
                    >
                        Nacido en el Extranjero
                    </Button>
                </Grid>
            </Grid>

            <Grid container item xs={12} sm={6} flexDirection="column">
    {/* Etiqueta */}
    <Typography variant="subtitle1">Grupos</Typography>

    {/* MultiSelect de Grupos */}
    <Select
        isMulti
        options={groupOptions}
        value={values.groups
            .map((groupId) => groupOptions.find((group) => group.value == groupId))
            .filter(Boolean) // Filtrar valores nulos o indefinidos
        }
        onChange={(selectedOptions) =>
            setFieldValue(
                "groups",
                selectedOptions ? selectedOptions.map((option) => option.value) : []
            )
        }
        placeholder="Seleccione los Grupos"
        isClearable
        closeMenuOnSelect={false}
    />
</Grid>


        </Grid>
    );
});

export default PersonalInfoStep;
